import React from 'react';
import { CheckIcon } from 'lucide-react';
import { valueStack } from '../data/content';
type OfferStackProps = {
  id?: string;
  title: string;
  priceLabel: string;
  savingsLabel: string;
  ctaLabel: string;
  tone?: 'light' | 'dark';
};
export function OfferStack({
  id,
  title,
  priceLabel,
  savingsLabel,
  ctaLabel,
  tone = 'light'
}: OfferStackProps) {
  const isDark = tone === 'dark';
  return <section id={id} className={isDark ? 'bg-lilac-500 py-16 sm:py-20' : 'bg-cream py-16 sm:py-20'} aria-labelledby={`${id ?? 'stack'}-heading`} data-id="element-126" data-mp="1x5ps0ux9t5iv">
      <div className="mx-auto max-w-2xl px-5" data-id="element-127" data-mp="26wamc65wvnvz">
        <h2 id={`${id ?? 'stack'}-heading`} className={`text-center font-display text-3xl font-extrabold sm:text-4xl ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-128" data-mp="26x2h5erophl7">
          {title}
        </h2>

        <div className="mt-8 rounded-4xl border-2 border-white bg-white p-6 shadow-card sm:p-8" data-id="element-129" data-mp="1edn8nbt8vb4x">
          <ul className="divide-y divide-blush-100" data-id="element-130" data-mp="19f2d3poxtfmt">
            {valueStack.map(line => <li key={line.title} className="flex items-start justify-between gap-4 py-4" data-id="element-131" data-mp="14n9035qjd1ri">
                <span className="text-sm font-semibold leading-snug text-ink/85 sm:text-base" data-id="element-132" data-mp="19m3l8ebz72es">
                  {line.title}
                </span>
                <span className="shrink-0 font-display font-bold text-ink/50 line-through" data-id="element-133" data-mp="1je9cfluelfsx">
                  {line.price}
                </span>
              </li>)}
          </ul>

          <div className="mt-4 flex items-center justify-between border-t-2 border-dashed border-blush-200 pt-4" data-id="element-134" data-mp="qoitmzhttpqh">
            <span className="font-display text-lg font-bold text-ink" data-id="element-135" data-mp="vncb1308i0vx">Total value</span>
            <span className="font-display text-lg font-bold text-ink/50 line-through" data-id="element-136" data-mp="zq8sgqe1fqya">$85</span>
          </div>

          <div className="mt-3 flex items-center justify-between gap-3 rounded-2xl bg-blush-50 px-4 py-3" data-id="element-137" data-mp="272sgtqac18fq">
            <span className="font-display text-lg font-bold leading-tight text-blush-600" data-id="element-138" data-mp="2b3kr8muxxjdl">
              {priceLabel}
            </span>
            <span className="font-display text-3xl font-extrabold text-blush-500" data-id="element-139" data-mp="c28gpeyvvdja">$27</span>
          </div>

          <p className="mt-3 text-center font-display text-base font-bold text-mint-500" data-id="element-140" data-mp="l13nas5uapn4">
            {savingsLabel}
          </p>

          <a href="#checkout" className="mt-6 flex w-full items-center justify-center rounded-full bg-blush-500 px-6 py-5 text-center font-display text-lg font-bold text-white shadow-soft ring-4 ring-blush-200/60 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-blush-600 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-lilac-300 sm:text-xl" data-id="element-141" data-mp="g327qh7mh8ge">
            {ctaLabel}
          </a>

          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-semibold text-ink/70 sm:text-sm" data-id="element-142" data-mp="3tf2kty8gmj2q">
            {['Instant digital access', 'All 3 bonuses included', 'One-time payment'].map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-143" data-mp="1g9e1lynyzhcp">
                  <CheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-144" data-mp="1l1fmua348iev" />
                  {item}
                </li>)}
          </ul>
        </div>
      </div>
    </section>;
}